"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const hooks_1 = require("@nbc-design/hooks");
const AccordionClose_1 = require("@nbc-design/icons/lib/web/AccordionClose");
const AccordionOpen_1 = require("@nbc-design/icons/lib/web/AccordionOpen");
const tokens_json_1 = tslib_1.__importDefault(require("@nbc-design/tokens/dist/styles/tokens.json"));
require("./item.css");
/**
 * @ignore
 */
const ItemContext = React.createContext({});
/**
 * @ignore
 */
const Item = (props) => {
    const { index, children, disabled = false, className, open, onOpenChange, isOpen, defaultOpen, onToggleDone, } = props;
    const durationMs = parseInt(tokens_json_1.default['ad-long']?.replace('ms', ''), 10) || 200;
    const { isCollapseOpen, isAnimated, isContentHidden, maxHeight, toggle, innerRef } = (0, hooks_1.useCollapsible)({
        durationMs,
        onToggleDone,
        open: open,
        onOpenChange: onOpenChange,
        defaultOpen: defaultOpen ?? isOpen,
    });
    const collapseClass = (0, classnames_1.default)('dsc-collapsibleItem', isCollapseOpen ? 'is-show' : 'is-hidden', isAnimated && 'is-animated', className);
    const value = React.useMemo(() => ({
        toggle,
        index,
        maxHeight,
        descriptionContent: innerRef,
        disabled,
        isCollapseOpen,
        isContentHidden,
        onOpenChange,
    }), [toggle, index, maxHeight, innerRef, disabled, isCollapseOpen, isContentHidden, onOpenChange]);
    return ((0, jsx_runtime_1.jsx)("div", { className: collapseClass, children: (0, jsx_runtime_1.jsx)(ItemContext.Provider, { value: value, children: children }) }));
};
/**
 * @ignore
 */
const Header = ({ className, children }) => {
    return (0, jsx_runtime_1.jsx)("div", { className: className, children: children });
};
/**
 * @ignore
 */
const Button = ({ className, children }) => {
    const { toggle, isCollapseOpen, index, disabled } = React.useContext(ItemContext);
    const classes = (0, classnames_1.default)('dsc-collapsibleItem__collapseBtn', className);
    return ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: toggle, disabled: disabled, className: classes, "aria-expanded": !!isCollapseOpen, "aria-controls": `collapsibleItem-${index}`, children: children }));
};
/**
 * @ignore
 */
const ToggleIcons = (props) => {
    const { ariaLabelOpen, ariaLabelClose, label } = props;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", { className: "dsc-collapsibleItem__collapseIcon dsc-collapsibleItem__collapseIcon--open", children: [(0, jsx_runtime_1.jsx)(AccordionOpen_1.AccordionOpen, { size: "medium", title: ariaLabelOpen }), label && (0, jsx_runtime_1.jsx)("span", { className: "dsc-collapsibleItem__label", children: label.open })] }), (0, jsx_runtime_1.jsxs)("span", { className: "dsc-collapsibleItem__collapseIcon dsc-collapsibleItem__collapseIcon--close", children: [(0, jsx_runtime_1.jsx)(AccordionClose_1.AccordionClose, { name: "accordion-close", size: "medium", title: ariaLabelClose }), label && (0, jsx_runtime_1.jsx)("span", { className: "dsc-collapsibleItem__label", children: label.close })] })] }));
};
/**
 * @ignore
 */
const Body = ({ className, children }) => {
    const { index, maxHeight, descriptionContent, isContentHidden } = React.useContext(ItemContext);
    const classes = (0, classnames_1.default)('dsc-collapsibleItem__description', className);
    return ((0, jsx_runtime_1.jsx)("div", { style: { maxHeight }, id: `collapsibleItem-${index ?? ''}`, className: classes, hidden: isContentHidden, children: (0, jsx_runtime_1.jsx)("div", { ref: descriptionContent, children: children }) }));
};
Item.Header = Header;
Item.Body = Body;
Item.Button = Button;
Item.ToggleIcons = ToggleIcons;
Item.displayName = 'Item';
exports.default = Item;
//# sourceMappingURL=item.js.map